import type {Moment} from 'moment-timezone'
import moment from 'moment-timezone'
import {exhaustive} from '@freckle/exhaustive'
import type {FancyOk, fancyOperations} from '@freckle/educator-entities/ts/openapi-clients'
import {extractData, fancyClient} from '@freckle/educator-entities/ts/openapi-clients'

export type LicenseSubjectT = 'Math' | 'Ela' | 'Science' | 'SocialStudies'
export const LicenseSubjects = {
  Math: 'Math' as const,
  Ela: 'Ela' as const,
  Science: 'Science' as const,
  SocialStudies: 'SocialStudies' as const,
  all: function (): Array<LicenseSubjectT> {
    return [
      LicenseSubjects.Math,
      LicenseSubjects.Ela,
      LicenseSubjects.SocialStudies,
      LicenseSubjects.Science,
    ]
  },
  forDisplay: function (licenseSubject: LicenseSubjectT): string {
    switch (licenseSubject) {
      case 'Math':
        return 'Math'
      case 'Ela':
        return 'ELA'
      case 'Science':
        return 'Science'
      case 'SocialStudies':
        return 'Social Studies'
      default:
        return exhaustive(licenseSubject)
    }
  },
}

export type LicenseAttrs = {
  subject: LicenseSubjectT
  expires: Moment
  licensesUtilized: number | undefined | null
  licensesUtilizedAsOf: Moment | undefined | null
  licensesTotal: number
}

// We only want the school admin version of the API response
type SchoolLicensesArray = Extract<FancyOk<fancyOperations['getSchoolLicensesR']>, unknown[]>
export type ApiLicenseAttrs = Extract<SchoolLicensesArray[number], {licensesTotal: number}>

export async function fetchLicenses(schoolId: number): Promise<Array<LicenseAttrs>> {
  return fancyClient
    .GET('/2/schools/{SchoolP-SchoolId}/licenses', {
      params: {path: {'SchoolP-SchoolId': schoolId}},
    })
    .then(extractData)
    .then(a => a as Array<ApiLicenseAttrs>)
    .then(data =>
      data.map(a => ({
        subject: a.subject as LicenseSubjectT,
        expires: moment(a.expires),
        licensesUtilized: a.licensesUtilized,
        licensesUtilizedAsOf:
          a.licensesUtilizedAsOf !== null &&
          a.licensesUtilizedAsOf !== undefined &&
          a.licensesUtilizedAsOf !== ''
            ? moment(a.licensesUtilizedAsOf)
            : null,
        licensesTotal: a.licensesTotal,
      })),
    )
}
